var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaintenance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3000 3000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3000,
    height: 3000,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 195.028,
    height: 195.028,
    x: 525.071,
    y: 447.345,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502
  }), /*#__PURE__*/React.createElement("line", {
    x1: 622.585,
    x2: 622.585,
    y1: 480.666,
    y2: 609.051,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502
  }), /*#__PURE__*/React.createElement("line", {
    x1: 558.623,
    x2: 684.943,
    y1: 544.859,
    y2: 544.859,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502,
    d: "M2248.12846,1134.33981c39.85807,24.08084,86.38783,33.66435,131.77862,43.59617s91.83279,21.11176,130.10225,47.69227,67.05811,72.23219,60.7908,118.71625c-6.93428,51.431-52.5874,87.99342-97.72869,112.79364-41.47178,22.78421-86.27332,41.05267-121.298,73.02653s-58.67259,82.89937-42.56263,127.72328c10.95125,30.47041,37.5366,51.95675,62.93548,71.7708s52.03137,41.20141,63.156,71.60767-1.18344,71.90559-32.34375,79.65875"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502,
    d: "M2246.98653,1062.87157c39.41912,53.73563,106.69136,79.37507,172.21329,88.99693s132.3916,6.01423,197.9783,15.17479,133.05886,33.75657,173.58108,86.64837c31.42977,41.02384,42.06245,101.73431,13.956,145.149-17.28669,26.70186-46.06386,43.29346-74.56486,57.04389s-58.44436,26.07274-81.7616,47.59361-38.91985,55.16326-29.4313,85.594c7.2879,23.373,27.26237,39.89788,42.88878,58.64208,53.64324,64.34617,54.024,167.72042.85631,232.468"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1839.651,
    cy: 2709.985,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502,
    rx: 534.403,
    ry: 140.919
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1c0311",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.251,
    d: "M2268.09592,235.213a86.11661,86.11661,0,0,0-86.11725-86.117H992.89972a86.11662,86.11662,0,0,0-86.11725,86.117v9.93687H2268.09592Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502,
    d: "M906.78247,245.1499v930.109a86.11669,86.11669,0,0,0,86.11725,86.11726h1189.079a86.11668,86.11668,0,0,0,86.11725-86.11726V245.1499Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502,
    points: "1526.992 678.79 1526.992 692.297 1513.484 692.297"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1485.653,
    x2: 1054.272,
    y1: 692.297,
    y2: 692.297,
    fill: "none",
    stroke: "#1a1a1a",
    strokeDasharray: "27.831 27.831",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502,
    points: "1040.357 692.297 1026.849 692.297 1026.849 678.79"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1026.849,
    x2: 1026.849,
    y1: 653.096,
    y2: 357.621,
    fill: "none",
    stroke: "#1a1a1a",
    strokeDasharray: "25.694 25.694",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502,
    points: "1026.849 344.774 1026.849 331.267 1040.357 331.267"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1068.188,
    x2: 1499.569,
    y1: 331.267,
    y2: 331.267,
    fill: "none",
    stroke: "#1a1a1a",
    strokeDasharray: "27.831 27.831",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502,
    points: "1513.484 331.267 1526.992 331.267 1526.992 344.774"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1526.992,
    x2: 1526.992,
    y1: 370.468,
    y2: 665.943,
    fill: "none",
    stroke: "#1a1a1a",
    strokeDasharray: "25.694 25.694",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502,
    points: "2148.029 1149.621 2148.029 1163.128 2134.522 1163.128"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2106.691,
    x2: 1675.31,
    y1: 1163.128,
    y2: 1163.128,
    fill: "none",
    stroke: "#1a1a1a",
    strokeDasharray: "27.831 27.831",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502,
    points: "1661.394 1163.128 1647.887 1163.128 1647.887 1149.621"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1647.887,
    x2: 1647.887,
    y1: 1121.867,
    y2: 358.651,
    fill: "none",
    stroke: "#1a1a1a",
    strokeDasharray: "27.753 27.753",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502,
    points: "1647.887 344.774 1647.887 331.267 1661.394 331.267"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1689.225,
    x2: 2120.606,
    y1: 331.267,
    y2: 331.267,
    fill: "none",
    stroke: "#1a1a1a",
    strokeDasharray: "27.831 27.831",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502,
    points: "2134.522 331.267 2148.029 331.267 2148.029 344.774"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2148.029,
    x2: 2148.029,
    y1: 372.527,
    y2: 1135.744,
    fill: "none",
    stroke: "#1a1a1a",
    strokeDasharray: "27.753 27.753",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502
  }), /*#__PURE__*/React.createElement("rect", {
    width: 451.497,
    height: 795.122,
    x: 1672.209,
    y: 349.636,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502,
    points: "1526.992 1149.621 1526.992 1163.128 1513.484 1163.128"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1485.653,
    x2: 1054.272,
    y1: 1163.128,
    y2: 1163.128,
    fill: "none",
    stroke: "#1a1a1a",
    strokeDasharray: "27.831 27.831",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502,
    points: "1040.357 1163.128 1026.849 1163.128 1026.849 1149.621"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1026.849,
    x2: 1026.849,
    y1: 1122.105,
    y2: 805.679,
    fill: "none",
    stroke: "#1a1a1a",
    strokeDasharray: "27.515 27.515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502,
    points: "1026.849 791.921 1026.849 778.414 1040.357 778.414"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1068.188,
    x2: 1499.569,
    y1: 778.414,
    y2: 778.414,
    fill: "none",
    stroke: "#1a1a1a",
    strokeDasharray: "27.831 27.831",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502,
    points: "1513.484 778.414 1526.992 778.414 1526.992 791.921"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1526.992,
    x2: 1526.992,
    y1: 819.436,
    y2: 1135.863,
    fill: "none",
    stroke: "#1a1a1a",
    strokeDasharray: "27.515 27.515",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502
  }), /*#__PURE__*/React.createElement("rect", {
    width: 450.831,
    height: 346.783,
    x: 1051.505,
    y: 797.379,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502,
    d: "M1387.0508,674.62791c-64.02587,29.80549-121.45325,64.04884-121.45325,64.04884s-57.4047-34.24335-121.43057-64.04884c-64.04969-29.80607-62.93463-60.16967-62.93463-60.16967v-244.557c0-64.02559,96.03938-81.6814,96.03938-81.6814h176.65051s96.06206,17.65581,96.06206,81.6814v244.557S1451.07667,644.82184,1387.0508,674.62791Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502,
    d: "M1265.59982,693.0701c-22.76859-12.88844-62.13038-34.3979-104.7659-54.24668-29.04832-13.51686-37.869-24.93292-40.10819-28.61841V369.90183c0-23.45373,44.40283-38.30231,60.71925-42.18858h168.33009c16.12813,3.82955,60.717,18.69175,60.717,42.18858V610.1914c-2.24146,3.68889-11.0644,15.11175-40.10819,28.63315C1327.74608,658.67333,1288.37521,680.1828,1265.59982,693.0701Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1c0311",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.251,
    d: "M1333.50288,476.17527V451.54069a75.835,75.835,0,1,0-151.66995,0v24.63458a13.93884,13.93884,0,0,0,27.87768,0l-.00114-24.63458a47.95844,47.95844,0,0,1,95.91687,0v24.63458a13.93884,13.93884,0,0,0,27.87768,0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1035.958,
    cy: 192.707,
    r: 26.498,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1135.324,
    cy: 192.707,
    r: 26.498,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1234.69,
    cy: 192.707,
    r: 26.498,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6.754,
    d: "M506.1883,2544.53872H2352.50811c243.316-60.23488,263.80358-281.113,181.48337-421.5984-70.55056-120.40026-198.12549-186.33439-393.28014-118.363-169.49292-197.39232-452.53722-287.81316-704.45652-229.19225-265.46658,61.77325-382.29361,262.50294-400.57356,295.23071-49.64042-54.57765-211.515-222.20463-345.32163-194.23077C542.74188,1907.24637,448.92326,2172.06584,506.1883,2544.53872Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502,
    d: "M685.24574,2545.04673H2264.38233c63.659-99.30672,58.90815-218.29-4.81348-288.86633-50.57059-56.011-122.04059-63.54465-144.43385-64.99506-17.14888-47.671-59.383-140.80066-154.06189-194.98479-149.17037-85.36947-369.40294-40.22737-529.58857,125.17542-21.68646-79.1637-102.79221-122.29327-170.9129-101.10325-56.84162,17.6816-96.87511,77.73156-91.47466,144.4333-146.23986-97.35685-334.22689-73.911-435.70663,40.92262C655.27778,2294.02,637.10991,2426.72314,685.24574,2545.04673Z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 324.163,
    x2: 2533.991,
    y1: 2545.047,
    y2: 2545.047,
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6.754
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1c0311",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.251,
    d: "M1860.30017,2587.19291c-5.84343-12.28663-11.56376-21.6848-11.56376-21.6848l-81.84552,23.26987s-5.84893,5.36473-14.68664,14.00582C1783.52205,2620.8427,1828.59,2608.60168,1860.30017,2587.19291Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502,
    d: "M1752.20425,2602.7838c-29.71624,29.05533-93.32025,95.2572-82.80623,119.996,13.64128,32.09632,61.7859,11.63494,95.4868-10.4313s109.92942-65.39614,107.52213-88.66588c-1.15857-11.2002-6.68544-25.08813-12.10678-36.48976C1828.59,2608.60168,1783.52205,2620.8427,1752.20425,2602.7838Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1c0311",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.251,
    d: "M2014.55992,2595.61374c-1.73566-13.27758-3.20311-22.21518-3.20311-22.21518l-75.42609,14.4433A192.67476,192.67476,0,0,0,1922.628,2606.622C1949.75337,2627.72985,1989.80775,2616.21445,2014.55992,2595.61374Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502,
    d: "M2014.55992 2595.61374c-24.75217 20.60071-64.80655 32.11611-91.93193 11.00825-5.74561 9.17489-11.96718 20.76147-15.5836 32.57393-8.02429 26.21193-45.47022 141.75849-10.69868 150.85245 34.77044 9.094 81.31019-21.3975 93.61373-62.58778s31.56183-48.67938 29.42165-83.45024C2018.31045 2626.60191 2016.3 2608.92636 2014.55992 2595.61374zM1639.58281 1493.09145s-186.43331 305.717-181.61887 433.29968 273.62072 658.776 300.90256 671.61451 80.24068-8.82647 97.89363-24.87461-12.0361-97.09123-24.87461-136.40916-67.13471-273.08579-149.51514-403.61063c70.6118-100.56832 149.78261-233.23292 161.55124-330.59161s21.79992-219.88176 21.79992-219.88176"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502,
    d: "M1808.61572,1658.65472s60.598,371.24689,81.653,468.60559c7.14668,121.96583,19.98519,440.78881,29.61407,458.9767s89.86956,34.236,102.70807-22.46739,44.93478-201.13665,35.3059-341.29037c-5.34938-116.61646,40.65528-233.23292,51.354-278.1677s79.1708-338.08074-14.97826-487.86334l-297.42546,4.2795"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1c0311",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.251,
    d: "M1769.29779,1541.23586c70.6118-3.33136,108.32492,8.9729,144.43322,5.28886s176.99236-15.27163,196.68737-59.62826c-12.40127-37.93738-465.49365-4.25859-465.49365-4.25859l-21.70529,38.11321S1634.49344,1558.0864,1769.29779,1541.23586Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#54cafa",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502,
    d: "M1643.85485,1280.98858s5.34938,82.38043-11.76863,120.896-35.3059,126.24534,36.37577,124.10559,143.76456-11.558,186.29212.03845,225.07511-7.26011,257.17139-65.0334,58.5757-244.73408,50.55163-284.85442-43.87561-231.09317-113.011-247.1413S1728.375,945.04759,1728.375,945.04759"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#54cafa",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502,
    d: "M1831.8506,1268.37523c238.31483,68.20458,362.7228-56.92857,378.77094-194.94255s-105.1153-195.78726-147.64286-219.85946-86.65994-36.10831-158.07414-34.5035-136.9441,10.43129-136.9441,10.43129-236.44254,89.86956-248.21118,309.1941,251.42081,198.99689,379.8059,83.4503c75.96118-57.77329,72.75155-52.82511,77.566-72.08287s16.85054-115.54659-22.46739-91.87559-108.32492,117.1514-228.68594,107.52252l-52.95885-10.43129s-11.6349,2.40722-8.02407-4.41324,24.2728-18.656,27.08123-31.09326,4.41324-34.30289-9.82948-35.70711c6.61985-7.62286,22.668-3.61083,41.12334,8.22467s98.09424,38.64927,125.1086,43.46371"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502,
    d: "M1887.78653,764.77353c-134.26941-.53494-57.7733-170.64519-57.7733-170.64519l120.361-3.74456,29.95652,87.19487L1952.514,727.32788s-17.653,20.86257-13.37345,52.95885,41.19022,71.14673,41.19022,71.14673-73.82143,42.2601-163.691-2.67469c13.37344-31.02639,27.81677-60.448,30.81527-91.17765"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1c0311",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.251,
    d: "M1845.4602 770.89752s34.30226.49586 42.32633-6.124c-29.48846-1.50452-40.721-5.70916-40.721-5.70916zM1788.95675 526.59244c0 1.20361-38.11432 95.88761 73.42023 97.09122 37.71312 1.20361 45.73719-4.81444 53.76125-14.04212s25.27582 10.43129 12.43731 24.47341c14.04212 4.012 28.48544-.80241 28.08424 26.47942s-21.665 30.09026-30.09026 32.49748c9.62888 28.88665 22.06619 42.12636 32.09627 42.12636 21.665-4.41324 26.88063-4.012 34.5035-55.36607s19.659-81.44429-12.83851-113.13936c-29.28785-28.88665-53.25949-36.91072-86.00785-28.08424s-59.22779 17.65295-96.1385-16.85054C1790.16036 515.35874 1788.95675 526.59244 1788.95675 526.59244z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#54cafa",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502,
    d: "M1977.12115,1150.06254c89.86957-30.89267,70.6118-155.26572,70.6118-155.26572"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502,
    d: "M1684.51013,1095.09767s-40.92275-18.9903-78.10093,2.40722-35.84084,57.77329-23.2698,72.48408,41.72516-1.06987,50.28416-8.29154,11.50117-12.571,16.85055-13.106,24.87461,1.33734,24.87461,1.33734,22.35015-18.35426,28.61917-40.92275C1706.44258,1099.37717,1684.51013,1095.09767,1684.51013,1095.09767Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 188.566,
    height: 134.002,
    x: 1163.386,
    y: 466.011,
    fill: "#1c0311",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.251
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502,
    d: "M1977.12168,1065.67619s36.172-18.9904,68.73846.26739c-21.65788,63.67106-39.49048,73.06469-45.202,73.8215l-21.39736-9.36148C1986.3683,1110.06506,1984.83379,1088.35909,1977.12168,1065.67619Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502,
    d: "M1976.58621,1590.18268s24.60715,77.03105,106.98758,86.65993"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502,
    d: "M558.71856,972.63157V921.97552H506.45814a93.33087,93.33087,0,0,0-8.77872-21.2021l36.949-36.94866-35.82583-35.82611L461.8536,864.94787a93.318,93.318,0,0,0-21.2021-8.779V803.9314h-50.633v52.23748a93.318,93.318,0,0,0-21.2021,8.779l-36.94894-36.94922-35.82583,35.82611,36.949,36.94866a93.33133,93.33133,0,0,0-8.77872,21.2021H271.95147v50.65605h52.26042a93.321,93.321,0,0,0,8.77872,21.2021l-36.949,36.94894,35.82583,35.82583,36.94894-36.94895a93.31728,93.31728,0,0,0,21.2021,8.77872v52.23747h50.633v-52.23747a93.31728,93.31728,0,0,0,21.2021-8.77872l36.94894,36.94895,35.82583-35.82583-36.949-36.94894a93.32053,93.32053,0,0,0,8.77872-21.2021Zm-99.5239,0a50.66558,50.66558,0,0,1-18.54316,18.54316,49.43078,49.43078,0,0,1-12.217,5.06577,50.85587,50.85587,0,0,1-26.22185,0,49.27041,49.27041,0,0,1-12.19409-5.06577,50.92236,50.92236,0,0,1-23.63174-30.76034,51.39151,51.39151,0,0,1-1.69614-13.11085,50.40063,50.40063,0,0,1,1.71909-13.11085,49.441,49.441,0,0,1,5.06563-12.21717,50.83783,50.83783,0,0,1,18.54316-18.54288,49.27006,49.27006,0,0,1,12.19409-5.06578,50.85587,50.85587,0,0,1,26.22185,0,49.43042,49.43042,0,0,1,12.217,5.06578,50.83783,50.83783,0,0,1,18.54316,18.54288,49.44065,49.44065,0,0,1,5.06563,12.21717,50.40063,50.40063,0,0,1,1.71909,13.11085,51.39151,51.39151,0,0,1-1.69614,13.11085A50.38319,50.38319,0,0,1,459.19466,972.63157Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 619.378,
    cy: 1397.242,
    r: 145.007,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1a1a1a",
    d: "M524.24532,1393.87529l83.9846,73.82123a16.88474,16.88474,0,0,0,24.88078-2.86044l132.93274-185.893a16.88383,16.88383,0,0,0-27.46724-19.64192L616.50043,1430.00848l-69.96188-61.49626a16.88371,16.88371,0,0,0-22.29213,25.36334Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1c0311",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.251,
    d: "M1056.84494,2206.66666c-22.999-21.44476-48.35378-48.3969-42.966-79.37754,4.06585-23.37967,24.44094-39.73672,38.83458-58.60374,19.9006-26.08541,29.195-60.82383,21.67829-92.761s-32.91292-59.8251-64.87231-67.24711-68.68051,7.96553-83.2151,37.38037c-11.39044,23.05218-8.80526,50.15642-11.15471,75.76168s-13.31584,54.34625-37.86424,61.996c-20.50322,6.38926-42.21458-4.58167-59.69973-17.05061s-34.8412-27.34424-56.14227-30.0774c-24.99768-3.20737-50.00225,12.31478-62.66132,34.10729s-14.42,48.56361-9.9813,73.37212,14.60044,48.17192,24.68053,71.2708l-66.27857,75.92769L625.4523,2544.53872H853.17517c23.47845-10.60031,45.40171-24.52966,67.16129-38.4083q26.96859-17.2012,53.93734-34.40226c12.16763-7.76079,25.66216-17.67472,26.472-32.08393,1.64227-29.22045-48.12811-40.52107-47.31124-69.77623.333-11.92405,9.96407-21.94255,20.94189-26.6095s23.20689-5.11733,35.11124-5.87839c18.24442-1.16653,36.81357-3.32049,53.39382-11.02191s31.07282-21.8388,35.00736-39.69208C1104.65645,2255.95731,1079.84407,2228.11143,1056.84494,2206.66666Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6.754,
    d: "M960.45145 2065.10838s-24.08166 139.99919-98.93516 208.87445-87.72674 161.13343-84.50843 201.89867-34.32863 68.65722-34.32863 68.65722M873.55712 2415.80641s-67.17838-23.10647-94.73706 17.41154M786.66279 2237.5954s31.76947 15.4248 29.83073 90.91767M967.96084 2204.47081s-22.67495 33.087-79.45834 39.07168"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502,
    d: "M726.95687,2486.17526c23.63234-46.37438-.12826-83.18493-39.38457-108.75974-38.77051-36.05251-9.5418-59.71516,24.94216-81.63249,61.96886-54.11824.29869-152.69939-75.54454-120.315-27.25331,13.19074-58.89954,51.02563-90.68451,28.90743-18.2644-14.46171-12.23473-42.68095-10.283-65.89652,6.06962-58.22266-37.82346-141.20919-104.21913-130.55749-29.57287,7.4041-46.4255,39.29089-73.93755,52.422-81.29206,35.30412-144.35-79.1246-223.59517-71.67792-153.6306,34.44772-104.89133,303.08169,115.14693,269.90852,17.58035,1.44993,35.9715,8.09875,45.79574,22.74769,31.9401,50.1093-49.78208,109.44062-19.24218,159.77669,26.62424,38.26254,79.482,18.51707,118.14737,17.71771,54.25257-1.66927,75.89849,45.69847,45.89673,85.72258H650.74151C682.33993,2533.80422,710.8474,2516.57367,726.95687,2486.17526Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502,
    d: "M511.76559 2544.53872l16.89612-32.18305c74.0211-255.85554-313.7851-389.41535-313.7851-389.41535M564.0631 2311.21138s8.88969 57.08856-31.22474 90.49672M400.46574 2122.94032c1.07277 2.68192 32.55152 55.46581 6.889 104.70412M404.22044 2305.85389s67.8063-7.84891 92.36909 14.04125M232.04092 2162.63279s36.95282 11.843 70.23754-1.05149"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 271.58,
    height: 26.113,
    x: 2326.895,
    y: 1900.8,
    fill: "#1c0311",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.251
  }), /*#__PURE__*/React.createElement("rect", {
    width: 271.58,
    height: 244.186,
    x: 2326.894,
    y: 1926.913,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502
  }), /*#__PURE__*/React.createElement("rect", {
    width: 271.58,
    height: 374.062,
    x: 2326.894,
    y: 2171.1,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502
  }), /*#__PURE__*/React.createElement("rect", {
    width: 271.58,
    height: 45.825,
    x: 2326.895,
    y: 1854.975,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2377.574,
    cy: 2014.345,
    r: 7.737,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2437.055,
    cy: 2014.345,
    r: 7.737,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2496.535,
    cy: 2014.345,
    r: 7.737,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2556.016,
    cy: 2014.345,
    r: 7.737,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2496.535,
    cy: 2110.316,
    r: 7.737,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2556.016,
    cy: 2110.316,
    r: 7.737,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2556.016,
    cy: 2202.555,
    r: 7.737,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502
  }), /*#__PURE__*/React.createElement("rect", {
    width: 134.436,
    height: 12.767,
    x: 2369.837,
    y: 2196.172,
    fill: "#1c0311",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.251
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2556.016,
    cy: 2278.767,
    r: 7.737,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502
  }), /*#__PURE__*/React.createElement("rect", {
    width: 134.436,
    height: 12.767,
    x: 2369.837,
    y: 2272.384,
    fill: "#1c0311",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.251
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2556.016,
    cy: 2354.98,
    r: 7.737,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502
  }), /*#__PURE__*/React.createElement("rect", {
    width: 134.436,
    height: 12.767,
    x: 2369.837,
    y: 2348.596,
    fill: "#1c0311",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.251
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2556.016,
    cy: 2431.192,
    r: 7.737,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502
  }), /*#__PURE__*/React.createElement("rect", {
    width: 134.436,
    height: 12.767,
    x: 2369.837,
    y: 2424.809,
    fill: "#1c0311",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.251
  }), /*#__PURE__*/React.createElement("rect", {
    width: 271.58,
    height: 26.113,
    x: 2624.588,
    y: 1900.8,
    fill: "#1c0311",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.251
  }), /*#__PURE__*/React.createElement("rect", {
    width: 271.579,
    height: 374.062,
    x: 2624.588,
    y: 2171.1,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502
  }), /*#__PURE__*/React.createElement("rect", {
    width: 271.579,
    height: 244.186,
    x: 2624.588,
    y: 1926.913,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502
  }), /*#__PURE__*/React.createElement("rect", {
    width: 271.58,
    height: 45.825,
    x: 2624.588,
    y: 1854.975,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2675.267,
    cy: 2014.345,
    r: 7.737,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2734.748,
    cy: 2014.345,
    r: 7.737,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2794.228,
    cy: 2014.345,
    r: 7.737,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2853.709,
    cy: 2014.345,
    r: 7.737,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2794.228,
    cy: 2110.316,
    r: 7.737,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2853.709,
    cy: 2110.316,
    r: 7.737,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2853.709,
    cy: 2202.555,
    r: 7.737,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502
  }), /*#__PURE__*/React.createElement("rect", {
    width: 134.436,
    height: 12.767,
    x: 2667.53,
    y: 2196.172,
    fill: "#1c0311",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.251
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2853.709,
    cy: 2278.767,
    r: 7.737,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502
  }), /*#__PURE__*/React.createElement("rect", {
    width: 134.436,
    height: 12.767,
    x: 2667.53,
    y: 2272.384,
    fill: "#1c0311",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.251
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2853.709,
    cy: 2354.98,
    r: 7.737,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502
  }), /*#__PURE__*/React.createElement("rect", {
    width: 134.436,
    height: 12.767,
    x: 2667.53,
    y: 2348.596,
    fill: "#1c0311",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.251
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2853.709,
    cy: 2431.192,
    r: 7.737,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502
  }), /*#__PURE__*/React.createElement("rect", {
    width: 134.436,
    height: 12.767,
    x: 2667.53,
    y: 2424.809,
    fill: "#1c0311",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.251
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502,
    points: "2896.167 2545.162 2955 2545.162 2955 1913.857 2896.167 1854.975 2896.167 2545.162"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2699.562,
    cy: 1090.676,
    r: 165.571,
    fill: "#1c0311",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.251
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.502,
    d: "M2714.96746,1061.29994a30.60273,30.60273,0,1,0-30.81044,0,62.0735,62.0735,0,0,0-46.64414,60.11948V1151.389h124.09873v-29.96953A62.07351,62.07351,0,0,0,2714.96746,1061.29994Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenance);
export default __webpack_public_path__ + "static/media/maintenance.a26b3c065f0465172e85d51152b42031.svg";
export { ForwardRef as ReactComponent };